import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["actionBar", "count", "form", "formPostpone"]

  connect() {
    this.updateUI()
  }

  toggle(event) {
    this.updateUI()
    this.syncFormsWithSelection()
  }

  updateUI() {
    const checkboxes = this.element.querySelectorAll('input[name="task_ids[]"]')
    const checked = Array.from(checkboxes).filter(cb => cb.checked)

    if (this.hasActionBarTarget) {
      this.actionBarTarget.classList.toggle("hidden", checked.length === 0)
    }

    if (this.hasCountTarget) {
      this.countTarget.textContent = checked.length
    }
  }

  syncFormsWithSelection() {
    const checkboxes = this.element.querySelectorAll('input[name="task_ids[]"]:checked')
    const selectedIds = Array.from(checkboxes).map(cb => cb.value)

    this.clearFormInputs(this.formTarget)
    this.clearFormInputs(this.formPostponeTarget)

    selectedIds.forEach(id => {
      this.addHiddenInput(this.formTarget, id)
      this.addHiddenInput(this.formPostponeTarget, id)
    })
  }

  clearFormInputs(form) {
    if (!form) return
    const existingInputs = form.querySelectorAll('input[name="task_ids[]"]')
    existingInputs.forEach(input => input.remove())
  }

  addHiddenInput(form, value) {
    if (!form) return
    const input = document.createElement("input")
    input.type = "hidden"
    input.name = "task_ids[]"
    input.value = value
    form.appendChild(input)
  }

  get selectedIds() {
    const checkboxes = this.element.querySelectorAll('input[name="task_ids[]"]:checked')
    return Array.from(checkboxes).map(cb => cb.value)
  }
}
